import asset_0 from "./assets/about/hero/images/background.png";
import asset_1 from "./assets/about/hero/images/character.png";
import asset_2 from "./assets/about/images/banner.png";
import asset_3 from "./assets/about/images/stat-clock.svg";
import asset_4 from "./assets/about/images/stat-eligibility.svg";
import asset_5 from "./assets/about/images/stat-nationwide.svg";
import asset_6 from "./assets/about/images/stat-partner-schools.svg";
import asset_7 from "./assets/champions/hero/images/background.png";
import asset_8 from "./assets/champions/profiles/images/champion-1.png";
import asset_9 from "./assets/champions/profiles/images/champion-2.png";
import asset_10 from "./assets/champions/profiles/images/champion-3.png";
import asset_11 from "./assets/champions/profiles/images/champion-4.png";
import asset_12 from "./assets/champions/profiles/images/champion-5.png";
import asset_13 from "./assets/home/hero-four/images/card-1.jpg";
import asset_14 from "./assets/home/hero-four/images/card-10.jpg";
import asset_15 from "./assets/home/hero-four/images/card-11.jpg";
import asset_16 from "./assets/home/hero-four/images/card-12.jpg";
import asset_17 from "./assets/home/hero-four/images/card-13.jpg";
import asset_18 from "./assets/home/hero-four/images/card-14.jpg";
import asset_20 from "./assets/home/hero-four/images/card-2.jpg";
import asset_21 from "./assets/home/hero-four/images/card-3.jpg";
import asset_22 from "./assets/home/hero-four/images/card-4.jpg";
import asset_23 from "./assets/home/hero-four/images/card-5.jpg";
import asset_24 from "./assets/home/hero-four/images/card-6.jpg";
import asset_25 from "./assets/home/hero-four/images/card-7.jpg";
import asset_26 from "./assets/home/hero-four/images/card-8.jpg";
import asset_27 from "./assets/home/hero-four/images/card-9.jpg";
import asset_28 from "./assets/home/hero-one/images/background.png";
import asset_29 from "./assets/home/hero-one/images/character.png";
import asset_30 from "./assets/home/hero-seven/images/profile-pic.png";
import asset_31 from "./assets/home/hero-seven/images/thumbnails/1.png";
import asset_32 from "./assets/home/hero-seven/images/thumbnails/2.png";
import asset_33 from "./assets/home/hero-seven/images/thumbnails/3.png";
import asset_34 from "./assets/home/hero-seven/images/thumbnails/4.png";
import asset_35 from "./assets/home/hero-seven/videos/1.mp4";
import asset_36 from "./assets/home/hero-seven/videos/2.mp4";
import asset_37 from "./assets/home/hero-seven/videos/3.mp4";
import asset_38 from "./assets/home/hero-seven/videos/4.mp4";
import asset_39 from "./assets/home/hero-three/images/poster.png";
import asset_40 from "./assets/home/hero-three/videos/Genius-Video1.mp4";
import asset_41 from "./assets/home/hero-two/images/eligibility-criteria.svg";
import asset_42 from "./assets/home/hero-two/images/key-focus-area.png";
import asset_43 from "./assets/home/hero-two/images/nationwide-coverage.svg";
import asset_44 from "./assets/home/hero-two/images/selection-process.png";
import asset_45 from "./assets/home/partner-schools/images/kd-jain.svg";
import asset_46 from "./assets/home/partner-schools/images/smt-vidya.svg";
import asset_47 from "./assets/home/partner-schools/images/sri-venkata-logo.svg";
import asset_48 from "./assets/home/partner-schools/images/st-xaviers-logo.svg";
import asset_49 from "./assets/olympiads/hots/images/hotsolympiad.jpg";
import asset_50 from "./assets/olympiads/math/images/matholympiad.jpg";
import asset_51 from "./assets/olympiads/score/images/score.jpg";
import asset_52 from "./assets/shared/images/logo.png";

export const CMS_ASSET_MAP: Record<string, string> = {
  "assets/about/hero/images/background.png": asset_0,
  "assets/about/hero/images/character.png": asset_1,
  "assets/about/images/banner.png": asset_2,
  "assets/about/images/stat-clock.svg": asset_3,
  "assets/about/images/stat-eligibility.svg": asset_4,
  "assets/about/images/stat-nationwide.svg": asset_5,
  "assets/about/images/stat-partner-schools.svg": asset_6,
  "assets/champions/hero/images/background.png": asset_7,
  "assets/champions/profiles/images/champion-1.png": asset_8,
  "assets/champions/profiles/images/champion-2.png": asset_9,
  "assets/champions/profiles/images/champion-3.png": asset_10,
  "assets/champions/profiles/images/champion-4.png": asset_11,
  "assets/champions/profiles/images/champion-5.png": asset_12,
  "assets/home/hero-four/images/card-1.png": asset_13,
  "assets/home/hero-four/images/card-10.png": asset_14,
  "assets/home/hero-four/images/card-11.png": asset_15,
  "assets/home/hero-four/images/card-12.png": asset_16,
  "assets/home/hero-four/images/card-13.png": asset_17,
  "assets/home/hero-four/images/card-14.png": asset_18,
  "assets/home/hero-four/images/card-2.png": asset_20,
  "assets/home/hero-four/images/card-3.png": asset_21,
  "assets/home/hero-four/images/card-4.png": asset_22,
  "assets/home/hero-four/images/card-5.png": asset_23,
  "assets/home/hero-four/images/card-6.png": asset_24,
  "assets/home/hero-four/images/card-7.png": asset_25,
  "assets/home/hero-four/images/card-8.png": asset_26,
  "assets/home/hero-four/images/card-9.png": asset_27,
  "assets/home/hero-one/images/background.png": asset_28,
  "assets/home/hero-one/images/character.png": asset_29,
  "assets/home/hero-seven/images/profile-pic.png": asset_30,
  "assets/home/hero-seven/images/thumbnails/1.png": asset_31,
  "assets/home/hero-seven/images/thumbnails/2.png": asset_32,
  "assets/home/hero-seven/images/thumbnails/3.png": asset_33,
  "assets/home/hero-seven/images/thumbnails/4.png": asset_34,
  "assets/home/hero-seven/videos/1.mp4": asset_35,
  "assets/home/hero-seven/videos/2.mp4": asset_36,
  "assets/home/hero-seven/videos/3.mp4": asset_37,
  "assets/home/hero-seven/videos/4.mp4": asset_38,
  "assets/home/hero-three/images/poster.png": asset_39,
  "assets/home/hero-three/videos/Genius-Video1.mp4": asset_40,
  "assets/home/hero-two/images/eligibility-criteria.svg": asset_41,
  "assets/home/hero-two/images/key-focus-area.png": asset_42,
  "assets/home/hero-two/images/nationwide-coverage.svg": asset_43,
  "assets/home/hero-two/images/selection-process.png": asset_44,
  "assets/home/partner-schools/images/kd-jain.svg": asset_45,
  "assets/home/partner-schools/images/smt-vidya.svg": asset_46,
  "assets/home/partner-schools/images/sri-venkata-logo.svg": asset_47,
  "assets/home/partner-schools/images/st-xaviers-logo.svg": asset_48,
  "assets/olympiads/hots/images/hotsolympiad.jpg": asset_49,
  "assets/olympiads/math/images/matholympiad.jpg": asset_50,
  "assets/olympiads/score/images/score.jpg": asset_51,
  "assets/shared/images/logo.png": asset_52
};

export function resolveCmsAssetPath(cmsPath: string): string | undefined {
  return CMS_ASSET_MAP[cmsPath];
}
